import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * V0.1: simple native <select> styled to match HoodDesk inputs.
 * Swap to Radix Select primitive in V0.2 when search/keyboard navigation needed.
 *
 * Renders a chevron in a wrapper to give the native control a polished feel
 * (browsers ignore custom arrows; we hide the native one and add our own).
 */
export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({ className, children, ...props }, ref) => (
  <span className="relative inline-flex w-full">
    <select
      ref={ref}
      className={cn(
        'flex h-10 w-full appearance-none rounded-vt-sm border border-vt-border bg-vt-surface px-3 pr-9 py-2 text-vt-14 text-vt-text shadow-vt-1 transition-[border-color,box-shadow] duration-vt ease-vt hover:border-vt-border-strong focus-visible:border-vt-primary-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-vt-primary-400/30 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      {children}
    </select>
    <ChevronDown
      className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-vt-text-soft"
      aria-hidden="true"
      strokeWidth={1.75}
    />
  </span>
));
Select.displayName = 'Select';
